<template>
  <div>
    <div class="tw-mb-10">
      <div class="tw-outline tw-outline-0 tw-relative tw-border-b-2 focus-within:tw-border-orange-medium">
        <input 
          v-model="email"
          type="text" 
          name="email" 
          placeholder=" "
          class="tw-block tw-py-4 tw-w-full tw-border-0 tw-appearance-none focus:tw-outline-0 tw-bg-transparent tw-border-transparent focus:tw-border-transparent focus:tw-ring-0" />
        <label for="email" class="tw-pointer-events-none tw-absolute tw-top-0 tw-py-4 tw--z-1 tw-duration-300 tw-origin-0">Email</label>
      </div>
    </div>

    <div class="tw-mb-10">
      <div class="tw-outline tw-outline-0 tw-relative tw-border-b-2 focus-within:tw-border-orange-medium">
        <input 
          v-model="password"
          type="password" 
          name="password" 
          placeholder=" "
          class="tw-block tw-py-4 tw-w-full tw-border-0 tw-appearance-none focus:tw-outline-0 tw-bg-transparent tw-border-transparent focus:tw-border-transparent focus:tw-ring-0" />
        <label for="email" class="tw-pointer-events-none tw-absolute tw-top-0 tw-py-4 tw--z-1 tw-duration-300 tw-origin-0">Password</label>
      </div>
    </div>

    <div class="text-right">
      <TwButton 
        cssClass="tw-bg-orange-medium hover:tw-bg-orange-dark tw-border-orange-medium tw-border-2 tw-rounded-full tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-mb-4 tw-py-3  tw-transition-all tw-duration-200" 
        @emit-click="submitLogin" 
        :isLoading="submittingLogin"
        :isDisabled="false" 
        buttonText="Submit"/>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, onMounted, ref, watch
  } from 'vue';
  import { useRoute } from 'vue-router';

  import { storeToRefs } from 'pinia'

  // Data
  import { useBasketStore } from '../../stores/basket';
  import { useUserStore } from '../../stores/user';
  import { useFlashMessageStore } from "../../stores/flashMessages";
  import type User from '../../classes/User';
  import type FlashMessage from '../../types/FlashMessage';
  import type ApiError from '../../types/ApiError'

  import { plainToClass } from 'class-transformer';
  import TwButton from '../../components/TwButton.vue';

  const basketStore = useBasketStore();
  const userStore = useUserStore();
  const flashMessageStore = useFlashMessageStore();
  
  const route = useRoute();

  const email = ref('');
  const password = ref('');
  const submittingLogin = ref(false);

  const { user } = storeToRefs(userStore);
  const prevUser = null as (User | null)

  watch(user, () => {
    const updatedVal = userStore.user
   
    if (updatedVal != prevUser) {
      submittingLogin.value = false
      // router.push()
    }
  })

  const submitLogin = ((event: Event) => {
    let basket_id = "";

    if (basketStore.basket != null && basketStore.basket.id != null) {
      basket_id = basketStore.basket.id
    }
    submittingLogin.value = true
    
    userStore.login(email.value, password.value, basket_id).catch((error: ApiError) => {
      submittingLogin.value = false
    });
  })

</script>